import React from 'react';
import KickImage from 'Reuseables/KickImage';
import classNames from 'classnames';
import { Button, Modal, Alert, InputGroup, InputGroupAddon, Input, Form, FormGroup } from 'reactstrap';
import { hasError, convertToRupiah, getCloudImageUrl } from '../../../utils';
import { RESOURCE_URL } from '../../../config';
import { FormFeedback } from '../../Forms';
const bcaIcon = `${RESOURCE_URL}icons/bca.png`;
const userBalanceIcon = `${RESOURCE_URL}icons/kickcredit.png`;
import ArrowPrev from "../../../images/arrow/luxury_prev.png";

const isDisabled = (value, max) => {
  return value == 0 || parseInt(value) > parseInt(max)
}

const BankSection = ({ accountNumber, bankName }) => (
  <div className="text-desc2">
    <p>Confirm cash out and transfer to {accountNumber} Bank {bankName}?</p>
  </div>
)

const ModalCashOutInformation = props => {
  const bankAccount = props.dataBank?props.dataBank.account_name + ' / ' + props.dataBank.bank_name + ' / ' + props.dataBank.account_number:null;
  return (
    <Modal
      modalClassName="modal-cashout-v3"
      isOpen={props.isOpen}
      toggle={props.onToggle}
    >
      <Form>
        <div className="cashout-content">
          <div className="confirmation-title">
            <span>Cash Out Information</span>
          </div>
          <div className="cashout-header">
            <div className="cashout-info">
              <div className="balance-icon">                
                <KickImage src={getCloudImageUrl(props.icon, 400)} />
              </div>
              <div className="balance-info">
                <span>{props.title}</span>
                <span>IDR {convertToRupiah(parseInt(props.balance))}</span>
              </div>
            </div>
          </div>
          <div className="text-desc2">
            <p>Please click the link inside the email we just sent you to approve or reject this cash out request. You must click the link within 5 minutes or you will have to create a new request. It can take up to 24 hours for the funds to enter your account. You can contact us on WhatsApp at +6281210005425 should you have any inquiries.</p>
          </div>
          <div className="cashout-button">
            <Button
              className="cashout-content"
              onClick={props.onToggle}
            >
              Done
            </Button>
          </div>
          <div className="cashout-button">
            <Button
              className="cashout-content black"
              onClick={props.goToWalletHistory}
            >
              Go to Wallet History
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
)}

export default ModalCashOutInformation;